export function useHero() {
  const { $io } = useNuxtApp()

  const route = useRoute()
  const routeName = computed(() => route.name)

  const heroMedia = computed(() => $io.heroMediaObject) // global media settings object
  const heroContent = computed(() => $io.heroContentObject) // global content settings object

  type IOHeroTransition = {
    mode: 'out-in' | 'duo'
  }

  type IOHeroMedia = {
    type: 'image' | 'video' 
    src: string
    alt: string
  } 

  // Define IOHeroSettings type
  interface IOHeroSettings {
    media?: any
    content?: any
    overlays?: any
    shapes?: any
    divider?: any
    [key: string]: any // Index signature
  }


  const pages = {

    'about-us': {
      media: {
        type: 'video',
        transition: {
          mode: 'out-in'
        },
        media: {
          source: 'vimeo',
          vid: '1014746311', // yt  acFoMM4aGNs
          image: '/droplets-splash-1.jpg',
          alt: '',  
        },
      },
      content: {
        model: "page",
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: '360 DEGREE SERVICE',
          title: '<span><span class="sky-blue">Purity</span>, Expertise, and Flexibility Combined</span>',
          description: 'Welcome to the forefront of innovation in ethanol and ethanol blend solutions. At iSolvents, we specialise in crafting high-quality ethanol products, ranging from pure, natural to synthetic ethanol up to <span class="sky-blue">99.99% purity</span>, available both undenatured and denatured. ',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(128, 0, 128, 0)', 'rgba(0, 0, 255, 0)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {

          },
          options: {

          },
        }
      }
    },

    'our-service': {
      media: {
        type: 'image',
        transition: {
          mode: 'out-in'
        },
        media: {
          src: '/images/industries/energy-and-biofuel.jpg',
          alt: '360 degree service',
        },
      },
      content: {
        model: "page",
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'iSolvents - More Than Just Solvents',
          title: '<span class="focus">Unlocking Industry Potentials</span><br/>Through <span class="sky-blue">Tailored 360&deg;</span> Excellence.',
          description: 'From the initial complimentary assessment to the continuous refinement of solutions, our holistic approach encapsulates a 360-degree service model, tailored precisely to your unique needs.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(128, 0, 128, 0.2)', 'rgba(0, 0, 255, 0.2)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {

          },
          options: {

          },
        }
      }
    },

    // Solutions
    // Ethanal Blending
    'solutions-ethanol-blending': {
      media: {
        type: 'image',
        transition: {
          mode: 'out-in'
        },
        media: {
          src: '/images/page/solution/ethanol-blending/ethanol-blending.jpg',
          alt: 'Ethanol Blending',
        },
      },
      content: {
        model: "page",
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'ETHANOL AND ETHANOL BLENDS',
          title: '<span class="sky-blue">Purity</span>, Expertise,<br/>and Flexibility Combined',
          description: 'Welcome to the forefront of innovation in ethanol and ethanol blend solutions. At iSolvents, we specialise in crafting high-quality ethanol products, ranging from pure, natural to synthetic ethanol up to <span class="sky-blue">99.99% purity</span>, available both undenatured and denatured. ',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(128, 0, 128, 0.5)', 'rgba(0, 0, 255, 0.5)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {

          },
          options: {

          },
        }
      }
    },

    // Essential Chemicals
    'solutions-essential-chemicals': {
      media: {
        type: 'image',
        transition: {
          mode: 'out-in'
        },
        media: {
          src: '/images/page/solution/essential-chemicals/essential-chemicals-header.jpg',
          alt: '',
        },
      },
      content: {
        model: "page",
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'ESSENTIAL CHEMICALS',
          title: '<span class="sky-blue">Core Chemistry:</span> <br/>The Foundation of Innovation',
          description: 'Discover our premium range of essential chemicals, meticulously crafted to empower your products with quality and innovation. At iSolvents, we blend science, expertise, and reliability to create the building blocks essential for your groundbreaking solutions.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to right',
            colors: ['rgba(128, 0, 128, 0.4)', 'rgba(0, 0, 255, 0.4)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shape: {

        },
        // shapes: [
        //   {
        //     type: 'circle',
        //     options: {
        //       size: '100px',
        //       color: 'var(--c-cyan)',
        //     },
        //   }
        // ]
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {

          },
          options: {

          },
        }
      }
    },

    // Manufactured Products
    'solutions-manufactured-products': {
      media: {
        type: 'image',
        transition: {
          mode: 'out-in'
        },
        media: {
          src: '/images/page/solution/manufactured-products/manufactured-header.jpg',
          alt: '',
        },
      },
      content: {
        model: "page",
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'MANUFACTURED PRODUCTS',
          title: '<span class="focus">Precision-Crafted Products</span><br/> for Everyday Excellence',
          description: 'Discover our diverse range of manufactured products, crafted to serve both B2B and B2C markets. From luxurious perfume bases to essential sanitisers, each product embodies our dedication to quality, ensuring they meet your varied distribution requirements.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to right',
            colors: ['rgb(21 9 109 / 50%)', 'rgb(114 43 123 / 23%)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {

          },
          options: {

          },
        }
      }
    },

    // Manufacturing as a service
    'solutions-manufacturing-as-a-service': {
      media: {
        type: 'image',
        transition: {
          mode: 'out-in'
        },
        media: {
          type: 'image',
          src: '/images/page/solution/manufacturing-as-a-service/industries.jpg',
          alt: '',
        },
      },
      content: {
        model: "page",
        transition: {
          mode: 'out-in'
        },
        content: {
          model: "page",
          hairline: 'MANUFACTURING AS A SERVICE',
          title: '<span class="focus">Custom Manufacturing:</span> <br/>Transforming Ideas into Reality',
          description: 'Delve into our versatile manufacturing services, from creating basic ethanol blends to complex lubricants and perfume bases. We support your unique operational needs, ensuring precision, compliance, and excellence at every step.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(142, 45, 226, 0.1)', 'rgba(74, 0, 224, 0.1)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {

          },
          options: {

          },
        }
      }
    },

    'products': {
      media: {
        transition: {
          mode: 'out-in'
        },
        media: {
          src: '/custom-solutions.jpg',
          alt: '',
        },
      },
      content: {
        model: "page",
          content: {
          hairline: 'Our Products',
          title: '<span class="focus">Precision-Crafted Products</span><br/> for Everyday Excellence',
          description: 'Explore our range of ethanol blends, essential chemicals, and custom-manufactured products designed to drive efficiency, sustainability, and growth.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to right',
            colors: ['rgb(21 9 109 / 50%)', 'rgb(114 43 123 / 23%)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {

          },
          options: {

          },
        }
      }
    },
    // 'solutions-custom-manufacturing': {
    //   media: {
    //     transition: {
    //       mode: 'out-in'
    //     },
    //     media: {
    //       type: 'image',
    //       src: '/custom-manufacturing.jpg',
    //       alt: '',
    //     },
    //   },
    //   content: {
    //     transition: {
    //       mode: 'out-in'
    //     },
    //     content: {
    //       hairline: 'CUSTOM MANUFACTURING',
    //       title: '<span><span class="sky-blue">Custom Manufacturing:</span> <br/>Transforming Ideas into Reality</span>',
    //       description: 'Delve into our versatile manufacturing services, from creating basic ethanol blends to complex lubricants and perfume bases. We support your unique operational needs, ensuring precision, compliance, and excellence at every step.',
    //       line: true,
    //       lineColor: 'var(--c-cyan)',
    //     }
    //   },
    //   overlays: {
    //     transition: {
    //       mode: 'out-in'
    //     },
    //     overlays: [{
    //       type: 'gradient',
    //       options: {
    //         direction: 'to bottom',
    //         colors: ['rgba(142, 45, 226, 0.4)', 'rgba(74, 0, 224, 0.4)'],
    //       },
    //     }]
    //   },
    //   shapes: {
    //     transition: {
    //       mode: 'out-in'
    //     },
    //     shapes: []
    //   },
    //   divider: {
    //     transition: {
    //       mode: 'out-in'
    //     },
    //     divider: {
    //       shape: 0,
    //       styles: {

    //       },
    //       options: {

    //       },
    //     }
    //   }
    // },

    'contact-us': {
      media: {
        type: 'image',
        transition: {
          mode: 'out-in'
        },
        media: {
          type: 'image',
          src: '/droplets-splash-2.jpg',
          alt: '',
        },
      },
      content: {
        model: "page",
        content: {
          hairline: 'Contact Us',
          title: '<span class="sky-blue">Get in Touch with Us</span><br/>We\'ve got you covered.',
          description: 'We’re thrilled that you’re considering reaching out to us. At iSolvents, we take pride in offering a full range of innovative solutions tailored to your specific needs. Get in touch today to request your free, comprehensive assessment.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(0, 24, 158, 0.2)', 'rgba(0, 30, 190, 0.2)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {

          },
          options: {

          },
        }
      }
    },

    // Applications
    'applications': {
      media: {
        transition: {
          mode: 'out-in'
        },
        media: {
          src: '/images/page/applications/applications1.jpg',
          alt: '',
        },
      },
      content: {
        model: "page",
        content: {
          hairline: 'Industry Leading Applications',
          title: '<span class="sky-blue">Unlocking Applications</span>: Explore Ethanol\'s Versatility',
          description: 'Welcome to the forefront of innovation in ethanol and ethanol blend solutions. At iSolvents, we specialise in crafting high-quality ethanol products, ranging from pure, natural to synthetic ethanol up to 99.99% purity, available both undenatured and denatured. Our expertise lies not just in the product, but in understanding its myriad applications, ensuring we provide the perfect blend for your specific needs.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(0, 24, 158, 0.2)', 'rgba(0, 30, 190, 0.2)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {

          },
          options: {

          },
        }
      }
    },



    // Industries
    'industries': {
      media: {
        type: "image",
        transition: {
          mode: 'out-in'
        },
        media: {
          src: '/images/page/industries/industrial2.jpg',
          alt: '',
        },
      },
      content: {
        model: "page",
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'Empowering Various industries with powerful solutions',
          title: "<span class=\"focus\">Unlocking Industries</span><br/>Explore Ethanol's Versatility",
          description: 'Welcome to the forefront of innovation in ethanol and ethanol blend solutions. At iSolvents, we specialise in crafting high-quality ethanol products, ranging from pure, natural to synthetic ethanol up to 99.99% purity, available both undenatured and denatured. Our expertise lies not just in the product, but in understanding its myriad applications, ensuring we provide the perfect blend for your specific needs.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to right',
            colors: ['rgb(0 36 64 / 14%)', 'rgb(3 19 108 / 32%)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {

          },
          options: {

          },
        }
      }
    },





'industry-agriculture': {
  media: {
    type: 'image',
    transition: {
      mode: 'out-in'
    },
    media: {
      src: '/images/agriculture.jpg',
      alt: 'Agriculture',
    },
  },
  content: {
    model: "page",
    content: {
      hairline: 'Cultivating Efficiency, Quality, and Sustainability',
      title: '<span><span class="sky-blue">Enhancing Agricultural Productivity</span> with Specialised Ethanol Solutions</span>',
      description: 'iSolvents supports the agricultural sector by supplying high-quality ethanol, bespoke solvent formulations, and a 360° service model that ensures operational excellence, compliance, and sustainable innovation.',
      line: true,
      lineColor: 'var(--c-cyan)',
    }
  },
  overlays: {
    transition: {
      mode: 'out-in'
    },
    overlays: [{
      type: 'gradient',
      options: {
        direction: 'to bottom',
        colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
      },
    }]
  },
  shapes: {
    transition: {
      mode: 'out-in'
    },
    shapes: []
  },
  divider: {
    transition: {
      mode: 'out-in'
    },
    divider: {
      shape: 0,
      styles: {},
      options: {},
    }
  }
},

// Industries - Construction and Building Materials
'industry-construction-and-building-materials': {
  media: {
    type: 'image',
    media: {
      src: '/images/construction-building-materials.jpg',
      alt: 'Construction and Building Materials',
    },
  },
  content: {
    transition: {
      mode: 'out-in'
    },
    content: {
      hairline: 'Strengthening Durability, Efficiency, and Sustainability',
      title: '<span><span class="sky-blue">Revolutionizing Construction & Building Materials</span> with Specialised Ethanol Solutions</span>',
      description: 'iSolvents supports the construction and building materials sector by supplying high-purity ethanol, bespoke solvent formulations, and a 360° service model that ensures production consistency, compliance, and sustainable innovation.',
      line: true,
      lineColor: 'var(--c-cyan)',
    }
  },
  overlays: {
    transition: {
      mode: 'out-in'
    },
    overlays: [{
      type: 'gradient',
      options: {
        direction: 'to bottom',
        colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
      },
    }]
  },
  shapes: {
    transition: {
      mode: 'out-in'
    },
    shapes: []
  },
  divider: {
    transition: {
      mode: 'out-in'
    },
    divider: {
      shape: 0,
      styles: {},
      options: {},
    }
  }
},

// Industries - Cosmetics and Personal Care
'industry-cosmetics-and-personal-care': {
  media: {
    type: 'image',
    media: {
      src: '/images/cosmetics-personal-care.jpg',
      alt: 'Cosmetics and Personal Care',
    },
  },
  content: {
    model: "page",
    content: {
      hairline: 'Enhancing Formulations, Safety, and Brand Integrity',
      title: '<span><span class="sky-blue">Elevating Cosmetics & Personal Care Products</span> with Specialised Ethanol Solutions</span>',
      description: 'iSolvents supports the cosmetics and personal care industry by supplying premium-grade ethanol, bespoke solvent formulations, and a 360° service model that ensures purity, compliance, and product excellence.',
      line: true,
      lineColor: 'var(--c-cyan)',
    }
  },
  overlays: {
    transition: {
      mode: 'out-in'
    },
    overlays: [{
      type: 'gradient',
      options: {
        direction: 'to bottom',
        colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
      },
    }]
  },
  shapes: {
    transition: {
      mode: 'out-in'
    },
    shapes: []
  },
  divider: {
    transition: {
      mode: 'out-in'
    },
    divider: {
      shape: 0,
      styles: {},
      options: {},
    }
  }
},

// Industries - Energy and Biofuels
'industry-energy-and-biofuels': {
  media: {
    type: 'image',
    media: {
      src: '/images/energy-biofuels.jpg',
      alt: 'Energy and Biofuels',
    },
  },
  content: {
    transition: {
      mode: 'out-in'
    },
    content: {
      hairline: 'Driving Efficiency, Sustainability, and Innovation',
      title: '<span><span class="sky-blue">optimising Energy & Biofuel Production</span> with Specialised Ethanol Solutions</span>',
      description: 'iSolvents supports the energy and biofuels sector by supplying high-quality ethanol, tailored solvent formulations, and a 360° service model that ensures efficiency, compliance, and environmental responsibility.',
      line: true,
      lineColor: 'var(--c-cyan)',
    }
  },
  overlays: {
    transition: {
      mode: 'out-in'
    },
    overlays: [{
      type: 'gradient',
      options: {
        direction: 'to bottom',
        colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
      },
    }]
  },
  shapes: {
    transition: {
      mode: 'out-in'
    },
    shapes: []
  },
  divider: {
    transition: {
      mode: 'out-in'
    },
    divider: {
      shape: 0,
      styles: {},
      options: {},
    }
  }
},

// Industries - Environmental Services
'industry-environmental-services': {
  media: {
    transition: {
      mode: 'out-in'
    },
    media: {
      type: 'image',
      src: '/images/environmental-services.jpg',
      alt: 'Environmental Services',
    },
  },
  content: {
    transition: {
      mode: 'out-in'
    },
    content: {
      hairline: 'Driving Sustainability, Compliance, and Effective Remediation',
      title: '<span><span class="sky-blue">Enhancing Environmental Services</span> with Specialised Ethanol Solutions</span>',
      description: 'iSolvents supports the environmental services sector by supplying high-purity ethanol, bespoke solvent formulations, and a 360° service model that ensures compliance, efficiency, and a commitment to ecological stewardship.',
      line: true,
      lineColor: 'var(--c-cyan)',
    }
  },
  overlays: {
    transition: {
      mode: 'out-in'
    },
    overlays: [{
      type: 'gradient',
      options: {
        direction: 'to bottom',
        colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
      },
    }]
  },
  shapes: {
    transition: {
      mode: 'out-in'
    },
    shapes: []
  },
  divider: {
    transition: {
      mode: 'out-in'
    },
    divider: {
      shape: 0,
      styles: {},
      options: {},
    }
  }
},

    // Industries - Food and Beverage
'industry-food-and-beverage': {
  media: {
    transition: {
      mode: 'out-in'
    },
    media: {
      type: 'image',
      src: '/images/food-beverage.jpg',
      alt: 'Food and Beverage',
    },
  },
  content: {
    transition: {
      mode: 'out-in'
    },
    content: {
      hairline: 'Enhancing Quality, Safety, and Efficiency',
      title: '<span><span class="sky-blue">Enhancing Food & Beverage Production</span> with Specialised Ethanol Solutions</span>',
      description: 'iSolvents supports the food and beverage industry by supplying premium-grade ethanol and bespoke solvent formulations, underpinned by a 360° service model that ensures purity, compliance, and sustainable innovation.',
      line: true,
      lineColor: 'var(--c-cyan)',
    }
  },
  overlays: {
    transition: {
      mode: 'out-in'
    },
    overlays: [{
      type: 'gradient',
      options: {
        direction: 'to bottom',
        colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
      },
    }]
  },
  shapes: {
    transition: {
      mode: 'out-in'
    },
    shapes: []
  },
  divider: {
    transition: {
      mode: 'out-in'
    },
    divider: {
      shape: 0,
      styles: {},
      options: {},
    }
  }
},

// Industries - Industrial Manufacturing
'industry-industrial-manufacturing': {
  media: {
    transition: {
      mode: 'out-in'
    },
    media: {
      type: 'image',
      src: '/images/industrial-manufacturing.jpg',
      alt: 'Industrial Manufacturing',
    },
  },
  content: {
    transition: {
      mode: 'out-in'
    },
    content: {
      hairline: 'Driving Efficiency, Safety, and Innovation',
      title: '<span><span class="sky-blue">optimising Industrial Manufacturing</span> with Specialised Ethanol Solutions</span>',
      description: 'iSolvents supports the industrial manufacturing sector by supplying high-quality ethanol, bespoke solvent formulations, and a 360° service model that ensures operational excellence, compliance, and sustainable growth.',
      line: true,
      lineColor: 'var(--c-cyan)',
    }
  },
  overlays: {
    transition: {
      mode: 'out-in'
    },
    overlays: [{
      type: 'gradient',
      options: {
        direction: 'to bottom',
        colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
      },
    }]
  },
  shapes: {
    transition: {
      mode: 'out-in'
    },
    shapes: []
  },
  divider: {
    transition: {
      mode: 'out-in'
    },
    divider: {
      shape: 0,
      styles: {},
      options: {},
    }
  }
},

// Industries - Laboratory and Research
'industry-laboratory-and-research': {
  media: {
    transition: {
      mode: 'out-in'
    },
    media: {
      type: 'image',
      src: '/images/laboratory-research.jpg',
      alt: 'Laboratory and Research',
    },
  },
  content: {
    transition: {
      mode: 'out-in'
    },
    content: {
      hairline: 'Advancing Accuracy, Safety, and Discovery',
      title: '<span><span class="sky-blue">Advancing Laboratory & Research Workflows</span> with Specialised Ethanol Solutions</span>',
      description: 'iSolvents supports laboratories and research institutions by supplying high-quality ethanol, bespoke solvent formulations, and a 360° service model that ensures analytical precision, regulatory compliance, and sustainable innovation.',
      line: true,
      lineColor: 'var(--c-cyan)',
    }
  },
  overlays: {
    transition: {
      mode: 'out-in'
    },
    overlays: [{
      type: 'gradient',
      options: {
        direction: 'to bottom',
        colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
      },
    }]
  },
  shapes: {
    transition: {
      mode: 'out-in'
    },
    shapes: []
  },
  divider: {
    transition: {
      mode: 'out-in'
    },
    divider: {
      shape: 0,
      styles: {},
      options: {},
    }
  }
},

// Industries - Paints and Coatings
'industry-paints-and-coatings': {
  media: {
    transition: {
      mode: 'out-in'
    },
    media: {
      type: 'image',
      src: '/images/paints-coatings.jpg',
      alt: 'Paints and Coatings',
    },
  },
  content: {
    transition: {
      mode: 'out-in'
    },
    content: {
      hairline: 'Elevating Durability, Finish, and Efficiency',
      title: '<span><span class="sky-blue">Revolutionizing Paints & Coatings</span> with Specialised Ethanol Solutions</span>',
      description: 'iSolvents supports the paints and coatings sector by supplying high-quality ethanol, bespoke solvent formulations, and a 360° service model that ensures formulation precision, compliance, and sustainable innovation.',
      line: true,
      lineColor: 'var(--c-cyan)',
    }
  },
  overlays: {
    transition: {
      mode: 'out-in'
    },
    overlays: [{
      type: 'gradient',
      options: {
        direction: 'to bottom',
        colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
      },
    }]
  },
  shapes: {
    transition: {
      mode: 'out-in'
    },
    shapes: []
  },
  divider: {
    transition: {
      mode: 'out-in'
    },
    divider: {
      shape: 0,
      styles: {},
      options: {},
    }
  }
},

// Industries - Pharmaceuticals and Healthcare
'industry-pharmaceuticals-and-healthcare': {
  media: {
    transition: {
      mode: 'out-in'
    },
    media: {
      type: 'image',
      src: '/images/industries/pharma.jpg',
      alt: 'Pharmaceuticals and Healthcare',
    },
  },
  content: {
    transition: {
      mode: 'out-in'
    },
    content: {
      hairline: 'Enabling Precision, Purity, and Progress',
      title: '<span><span class="sky-blue">Elevating Pharmaceuticals and Healthcare</span> with Advanced Ethanol Solutions</span>',
      description: 'iSolvents supports pharmaceutical and healthcare industries by delivering high-purity ethanol, tailored solvent formulations, and a 360° service model to ensure compliance, quality, and innovation.',
      line: true,
      lineColor: 'var(--c-sky-blue)',
    }
  },
  overlays: {
    transition: {
      mode: 'out-in'
    },
    overlays: [{
      type: 'gradient',
      options: {
        direction: 'to bottom',
        colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
      },
    }]
  },
  shapes: {
    transition: {
      mode: 'out-in'
    },
    shapes: []
  },
  divider: {
    transition: {
      mode: 'out-in'
    },
    divider: {
      shape: 0,
      styles: {},
      options: {},
    }
  }
},

// Industries - Printing and Packaging
'industry-printing-and-packaging': {
  media: {
    transition: {
      mode: 'out-in'
    },
    media: {
      type: 'image',
      src: '/images/printing-packaging.jpg',
      alt: 'Printing and Packaging',
    },
  },
  content: {
    transition: {
      mode: 'out-in'
    },
    content: {
      hairline: 'Enhancing Clarity, Consistency, and Sustainability',
      title: '<span><span class="sky-blue">Innovating Printing & Packaging</span> with Specialised Ethanol Solutions</span>',
      description: 'iSolvents supports the printing and packaging sector by supplying high-quality ethanol, bespoke solvent formulations, and a 360° service model that ensures vivid print quality, optimal ink performance, regulatory compliance, and sustainable production.',
      line: true,
      lineColor: 'var(--c-cyan)',
    }
  },
  overlays: {
    transition: {
      mode: 'out-in'
    },
    overlays: [{
      type: 'gradient',
      options: {
        direction: 'to bottom',
        colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
      },
    }]
  },
  shapes: {
    transition: {
      mode: 'out-in'
    },
    shapes: []
  },
  divider: {
    transition: {
      mode: 'out-in'
    },
    divider: {
      shape: 0,
      styles: {},
      options: {},
    }
  }
},

// Industries - Textiles and Dyes
'industry-textiles-and-dyes': {
  media: {
    transition: {
      mode: 'out-in'
    },
    media: {
      type: 'image',
      src: '/images/textiles-dyes.jpg',
      alt: 'Textiles and Dyes',
    },
  },
  content: {
    transition: {
      mode: 'out-in'
    },
    content: {
      hairline: 'Enhancing Colour, Quality, and Sustainability',
      title: '<span><span class="sky-blue">Enhancing Textiles & Dyes Production</span> with Specialised Ethanol Solutions</span>',
      description: 'iSolvents supports the textiles and dyes sector by supplying high-quality ethanol, bespoke solvent formulations, and a 360° service model that ensures consistency, compliance, and innovative performance.',
      line: true,
      lineColor: 'var(--c-cyan)',
    }
  },
  overlays: {
    transition: {
      mode: 'out-in'
    },
    overlays: [{
      type: 'gradient',
      options: {
        direction: 'to bottom',
        colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
      },
    }]
  },
  shapes: {
    transition: {
      mode: 'out-in'
    },
    shapes: []
  },
  divider: {
    transition: {
      mode: 'out-in'
    },
    divider: {
      shape: 0,
      styles: {},
      options: {},
    }
  }
},





    'applications-antiseptic-and-topical-uses': {
      media: {
        transition: {
          mode: 'out-in'
        },
        media: {
          type: 'image',
          src: '/images/applications/antiseptic.jpg',
          alt: 'Antiseptic and Topical Uses',
        },
      },
      content: {
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'Safeguarding Health, Hygiene, and Consumer Trust',
          title: '<span><span class="sky-blue">Transforming Antiseptic & Topical Formulations</span> with Specialised Ethanol Solutions</span>',
          description: 'iSolvents supports antiseptic and topical applications by supplying high-purity ethanol, bespoke solvent formulations, and a 360° service model that ensures product stability, skin safety, and global compliance.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {},
          options: {},
        }
      }
    },

    // Applications - Biofuel Production
    'application-biofuel-production': {
      media: {
        transition: {
          mode: 'out-in'
        },
        media: {
          type: 'image',
          src: '/images/applications/biofuels.jpg',
          alt: 'Biofuel Production',
        },
      },
      content: {
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'Driving Efficiency, Compliance, and Environmental Responsibility',
          title: '<span><span class="sky-blue">Transforming Biofuel Production</span> with Specialised Ethanol Solutions</span>',
          description: 'iSolvents supports biofuel production applications by supplying high-quality ethanol, bespoke solvent formulations, and a 360° service model that ensures feedstock optimisation, regulatory compliance, and sustainable growth.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {},
          options: {},
        }
      }
    },

    // Applications - Flavour and Fragrance Extraction
    'applications-Flavour-and-fragrance-extraction': {
      media: {
        transition: {
          mode: 'out-in'
        },
        media: {
          type: 'image',
          src: '/images/Flavour-fragrance-extraction.jpg',
          alt: 'Flavour and Fragrance Extraction',
        },
      },
      content: {
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'Capturing Essence, Quality, and Authenticity',
          title: '<span><span class="sky-blue">Transforming Flavour & Fragrance Extraction</span> with Specialised Ethanol Solutions</span>',
          description: 'iSolvents supports Flavour and fragrance extraction applications by supplying high-purity ethanol, bespoke solvent formulations, and a 360° service model that ensures optimal yield, authentic sensory profiles, and regulatory adherence.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {},
          options: {},
        }
      }
    },

    // Applications - Food Preservation
    'applications-food-preservation': {
      media: {
        transition: {
          mode: 'out-in'
        },
        media: {
          type: 'image',
          src: '/images/food-preservation.jpg',
          alt: 'Food Preservation',
        },
      },
      content: {
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'Extending Shelf Life, Enhancing Quality, and Ensuring Safety',
          title: '<span><span class="sky-blue">Transforming Food Preservation</span> with Specialised Ethanol Solutions</span>',
          description: 'iSolvents supports food preservation applications by supplying high-purity ethanol, bespoke solvent formulations, and a 360° service model that ensures microbial control, flavour integrity, and compliance with food safety standards.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {},
          options: {},
        }
      }
    },

    // Applications - Ink and Dye Production
    'applications-ink-and-dye-production': {
      media: {
        transition: {
          mode: 'out-in'
        },
        media: {
          type: 'image',
          src: '/images/ink-dye-production.jpg',
          alt: 'Ink and Dye Production',
        },
      },
      content: {
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'Enhancing Colour, Consistency, and Efficiency',
          title: '<span><span class="sky-blue">Transforming Ink & Dye Production</span> with Specialised Ethanol Solutions</span>',
          description: 'iSolvents supports ink and dye production applications by supplying high-purity ethanol, bespoke solvent formulations, and a 360° service model that ensures vibrant colours, stable formulations, and compliance with environmental and safety standards.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {},
          options: {},
        }
      }
    },

    // Applications - Solvents in Laboratories
    'applications-solvents-in-laboratories': {
      media: {
        transition: {
          mode: 'out-in'
        },
        media: {
          type: 'image',
          src: '/images/laboratory-ethanol-solvents.jpg',
          alt: 'Solvents in Laboratories',
        },
      },
      content: {
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'Advancing Accuracy, Safety, and Discovery',
          title: '<span><span class="sky-blue">Transforming Laboratory Workflows</span> with Specialised Ethanol Solvents</span>',
          description: 'iSolvents supports laboratory applications by supplying high-purity ethanol, bespoke solvent formulations, and a 360° service model that ensures analytical precision, regulatory compliance, and sustainable innovation.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {},
          options: {},
        }
      }
    },

    // Applications - Sterilisation and Disinfection
    'applications-sterilisation-and-disinfection': {
      media: {
        transition: {
          mode: 'out-in'
        },
        media: {
          type: 'image',
          src: '/images/sterilisation-disinfection.jpg',
          alt: 'Sterilisation and Disinfection',
        },
      },
      content: {
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'Ensuring Hygiene, Safety, and Compliance',
          title: '<span><span class="sky-blue">Transforming Sterilisation & Disinfection Processes</span> with Specialised Ethanol Solutions</span>',
          description: 'iSolvents supports sterilisation and disinfection applications by supplying high-quality ethanol, bespoke solvent formulations, and a 360° service model that ensures microbial control, regulatory compliance, and operational efficiency.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {},
          options: {},
        }
      }
    },

    // Applications - Thermal Insulation
    'applications-thermal-insulation': {
      media: {
        transition: {
          mode: 'out-in'
        },
        media: {
          type: 'image',
          src: '/images/thermal-insulation.jpg',
          alt: 'Thermal Insulation',
        },
      },
      content: {
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'Improving Durability, Energy Efficiency, and Process Control',
          title: '<span><span class="sky-blue">Transforming Thermal Insulation Production</span> with Specialised Ethanol Solutions</span>',
          description: 'iSolvents supports thermal insulation applications by supplying high-purity ethanol, bespoke solvent formulations, and a 360° service model that ensures consistent foam quality, compliance with safety standards, and sustainable production.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {},
          options: {},
        }
      }
    },

    // Applications - Time Travel
    'applications-time-travel': {
      media: {
        transition: {
          mode: 'out-in'
        },
        media: {
          type: 'image',
          src: '/images/time-travel.jpg',
          alt: 'Time Travel',
        },
      },
      content: {
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'Expanding Horizons, Defying Boundaries, and Inspiring Innovation',
          title: '<span><span class="sky-blue">Imagining the Transformation of Time Travel</span> with Specialised Ethanol Solutions</span>',
          description: 'While currently beyond our known scientific capabilities, iSolvents conceptually supports future time travel scenarios by hypothetically supplying high-purity ethanol, bespoke solvent formulations, and a 360° service model that could, in theory, ensure temporal stability, regulatory foresight, and sustainable experimentation.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(0, 24, 158, 0.8)', 'rgba(0, 30, 190, 0.8)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {},
          options: {},
        }
      }
    },

    // MSDS
    'sds': {
      media: {
        transition: {
          mode: 'out-in'
        },
        media: {
          type: 'image',
          src: '/images/page/solution/ethanol-blending/ethanol-blending.jpg',
          alt: '',
        },
      },
      content: {
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'SDS',
          title: '<span><span class="sky-blue">Safety Data Sheets</span> <br/>for all our products</span>',
          description: 'Discover our premium range of essential chemicals, meticulously crafted to empower your products with quality and innovation. At iSolvents, we blend science, expertise, and reliability to create the building blocks essential for your groundbreaking solutions.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(142, 45, 226, 0.1)', 'rgba(74, 0, 224, 0.1)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {

          },
          options: {

          },
        }
      }
    },

    // Home page
    'index': {
      media: {
        type: 'video',
        transition: {
          mode: 'out-in'
        },
        media: {
          source: 'vimeo',
          vid: '1069866232',
          image: '/droplets-splash-1.jpg',
          alt: '',
        },
      },
      content: {
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'Welcome to iSolvents',
          title: '<span><span class="purity">Purity</span>, Expertise, and Flexibility Combined</span>',
          description: 'Welcome to iSolvents, we <span class="sky-blue">pioneer, develop and deliver world class ethanol products and solutions</span> that empower industries across every sector.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to right',
            colors: ['rgb(255 255 255 / 20%) 50%', 'rgb(68 157 212 / 0%) 70%'],
          },
        }, {
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgb(31 124 181 / 40%) 0%', 'rgb(0 0 0 / 0%) 30%'],
          },
        }] 
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {

          },
          options: {

          },
        }
      }
    },

  }

  function updateHero(key: string, heroSettings: IOHeroSettings) {
    if (heroSettings) {
      Object.keys(heroSettings).forEach(settingKey => {
        if (typeof heroSettings[settingKey] === 'object' && heroSettings[settingKey] !== null) {
          ($io.hero as any)[settingKey] = { ...($io.hero as any)[settingKey], ...heroSettings[settingKey] }
        } else {
          ($io.hero as any)[settingKey] = heroSettings[settingKey]
        }
      })
      // the key is actually what can trigger the transitions
      $io.hero.key = key
    }
  }

  watch(routeName, (name, oldName) => {
    
    if (String(name)?.startsWith('product-')) {
      return
    }
    if (String(name)?.startsWith('blog-')) {
      return
    }
    if (String(name)?.startsWith('industry-')) {
      return
    }
    if (String(name)?.startsWith('application-')) {
      return
    }
    
    const heroSettings = pages[name as keyof typeof pages]
    if (heroSettings) {
      updateHero(String(name), heroSettings)
      return
    }
  }, {
    immediate: true
  })

  return { heroMedia, heroContent }

}